import './src/styles/global.css';

export const onClientEntry = () => {
  if (typeof window === 'undefined') return;

  const loadGTM = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-MLQT9MKC';
    document.head.appendChild(script);
  };

  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(loadGTM);
  } else {
    setTimeout(loadGTM, 3500);
  }
};
